<template>
  <Card>
    <div class="cardTitle">{{ $t('Стадии процедуры') }}</div>
    <div class="stageDate">{{ $t('Приём заявок до:') }}<span>{{ getStageDateTime(procedure.applicationDeadline) }} </span>
    </div>
    <div class="stageDate">{{ $t('Подведение итогов:') }}<span>{{ getStageDateTime(procedure.summingStart) }} </span>
    </div>
    <div v-if="supplierRequirements?.length > 0">
      <v-divider />
      <ProcedureSupplierRequirementsInfo
        :supplier-requirements="supplierRequirements"
      />
    </div>
  </Card>
</template>

<script>
import { formatMinuteTime } from '@/filters';
import Card from "@intec/vue-components/form/Card.vue";
import ProcedureSupplierRequirementsInfo from '@/components/supplierRequirements/ProcedureSupplierRequirementsInfo.vue';

export default {
  name: 'ProcedureStageInfo',
  components: {ProcedureSupplierRequirementsInfo, Card },
  props: {
    procedure: {
      type: Object,
      required: true
    },
    supplierRequirements: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      formatMinuteTime,
    }
  },
  methods: {
    getStageDateTime(dateTime){
      return dateTime ? formatMinuteTime(dateTime) : this.$t('Не указано');
    }
  },
}
</script>

<style lang="scss" scoped>
:deep(.v-divider) {
  margin-left: 10px;
  border-width: 1px !important;
  background-color: rgba(var(--intec-primary-color), 0.5);
}

.stageDate {
  padding-left: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;

  span {
    font-weight: 400;
  }
}
</style>
